import axios from 'axios'

export default {
    ping() {
        return axios.get(`/ping`)
    },
    getCities(keywords) {
        return axios.get(`/cities`, { params: { keywords: keywords } })
    },
    getFoLangs() {
        return axios.get(`/folangs`)
    },
    getIsoLangs() {
        return axios.get(`/isolangs`)
    },
    search(keywords) {
        return axios.get(`/search`, { params: { keywords: keywords } })
    },
}